<script>
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import CheckboxButton from "../../components/CheckboxButton.svelte";

	export let impactType;
	export let impact;
	export let impactDays;
	export let impactSeverity;
	export let impactOther = false;
	export let impactOtherDetails = null;
	export let disabled = null;
	export let required = null;

	const daysOptions = [
		{ label: "1", value: 1 },
		{ label: "2", value: 2 },
		{ label: "3", value: 3 },
		{ label: "4", value: 4 },
		{ label: "5", value: 5 },
		{ label: "6", value: 6 },
		{ label: "7", value: 7 },
		{ label: "8", value: 8 },
		{ label: "9", value: 9 },
		{ label: "10", value: 10 },
		{ label: "11", value: 11 },
		{ label: "12", value: 12 },
		{ label: "13", value: 13 },
		{ label: "14", value: 14 },
		{ label: "15", value: 15 },
		{ label: "16", value: 16 },
		{ label: "17", value: 17 },
		{ label: "18", value: 18 },
		{ label: "19", value: 19 },
		{ label: "20", value: 20 },
		{ label: "21", value: 21 },
		{ label: "22", value: 22 },
		{ label: "23", value: 23 },
		{ label: "24", value: 24 },
		{ label: "25", value: 25 },
		{ label: "26", value: 26 },
		{ label: "27", value: 27 },
		{ label: "28", value: 28 },
		{ label: "29", value: 29 },
		{ label: "30", value: 30 },
		{ label: "More than 30", value: 31 }
	];

	const severityOptions = [
		{ label: "1", value: 1 },
		{ label: "2", value: 2 },
		{ label: "3", value: 3 },
		{ label: "4", value: 4 },
		{ label: "5", value: 5 }
	];
</script>

<FormRow>
	<FormColumn>
		<CheckboxButton {disabled} id={impactType} label={impactType} bind:checked={impact} />
	</FormColumn>
</FormRow>

{#if impact}
	{#if !impactOther}
		<FormRow class="align-items-end">
			<FormColumn cols="6">
				<Select
					{required}
					{disabled}
					label="How long did this last? (in days)"
					id="{impactType.replace(' ', '')}_days"
					bind:value={impactDays}
					optionList={daysOptions}
					textProperty="label"
					valueProperty="value" />
			</FormColumn>
			<FormColumn cols="6">
				<Select
					{required}
					{disabled}
					label="How would you rate the severity of this experience? With 5 being very concerning, and 1 being very minor"
					id="{impactType.replace(' ', '')}_severity"
					bind:value={impactSeverity}
					optionList={severityOptions}
					textProperty="label"
					valueProperty="value" />
			</FormColumn>
		</FormRow>
	{:else}
		<FormRow class="align-items-end">
			<FormColumn>
				<TextArea
					{required}
					{disabled}
					id="{impactType.replace(' ', '')}_details"
					label="What did you experience?"
					bind:value={impactOtherDetails} />
			</FormColumn>
		</FormRow>
		<FormRow>
			<FormColumn>
				<Select
					{required}
					{disabled}
					label="How would you rate the severity of this experience? With 5 being very concerning, and 1 being very minor"
					id="{impactType.replace(' ', '')}_severity"
					bind:value={impactSeverity}
					optionList={severityOptions}
					textProperty="label"
					valueProperty="value" />
			</FormColumn>
		</FormRow>
	{/if}
{/if}
